import React,{useState, useEffect, useContext} from 'react'
import { useLocation } from 'react-router-dom'
import useCallRestApi from '../../../hooks/useCallRestApi'
import HeaderAdimn from '../../../components/headerAdmin/HeaderAdmin'
import './editCardBi.css'
import { searchCategoryBi } from '../../../config/systemFunctions'
import { BodyContext } from '../../../contexts/BodyProvider'
import SearchBI from '../../../components/search/searchBi/SearchBI'
import AdminEditCategoryBI from '../../../components/adminCardBI/adminEditCategoryBI/AdminEditCategoryBI'
import ModalEditCategoryBI from '../../../components/adminCardBI/modalEditCategoryBI/ModalEditCategoryBI'
import AdminEditCardBI from '../../../components/adminCardBI/adminEditCardBI/AdminEditCardBI'
import ModalEditCardBI from '../../../components/adminCardBI/modalEditCardBI/ModalEditCardBI'
import ModalDeleteBICategory from '../../../components/modal/modalDeleteBICategory/ModalDeleteBICategory'
import ModalDeleteBICard from '../../../components/modal/modalDeleteCardBI/ModalDeleteBICard'


const EditCardBI = () => {
    const [userLink, setUserLink] = useState<UserRouter>()
    const [categoriesBI, setCategoriesBI] = useState<CategoryBI[]>([]);
    const [cardsBI, setCardsBI] = useState<CardsConectaBI[]>([]);
    const [cardsBICategory, setCardsBICategory] = useState<CardsConectaBI[]>([]);
    //const [favCardsBI, setFavCardsBI] = useState<FavoriteBI[]>([])
    const [callRestApi] = useCallRestApi();
    const [showEditCategory, setShowEditCategory] = useState(false);
    const [showDeleteCardBI, setShowDeleteCardBI] = useState(false);
    const [showDeleteCategory, setShowDeleteCategory] = useState(false);
    const [showEditCard, setShowEditCard] = useState(false);
    const [idCategoryForDelete, setIdCategoryForDelete] = useState(0);
    const [idCardBIForDelete, setIdCardBIForDelete] = useState(0);
    const [nameCategoryForDelete, setNameCategoryForDelete] = useState("");
    const [nameCardBIForDelete, setNameCardBIForDelete] = useState("");
    const location = useLocation();
    const {searchValues, loadingAdminBIValue} = useContext(BodyContext);

    useEffect(()=>{
        if(location.state){
            let _state = location.state as UserRouter
            setUserLink(_state)
        }
    },[])

    //LIST BI CATEGORIES
  useEffect(() => {
    (async () => { 
      const link: ResourceLink = {
        href: `api/category_bi`,
        rel: "search",
        type: "GET",
      };

      callRestApi<CategoryBI[]>({
        link,
        onSuccess: (categoriesBI: CategoryBI[]) => {
          loadingAdminBIValue?.setLoadingAdminBI(true)
          setCategoriesBI(categoriesBI);
          loadingAdminBIValue?.setLoadingAdminBI(false)
        },
        onError: (err: ErrorApi) => {},
        onFinally: () => {},
      });
    })();
    
  }, [loadingAdminBIValue?.loadingAdminBI]);

  useEffect(() => {
    (async()=> {
      const link: ResourceLink = {
        href: `api/card_bi`,
        rel:"Loading",
        type:"GET",
      };

      callRestApi<CardsConectaBI[]>({
        link,
        onSuccess: (cardsBI: CardsConectaBI[]) => {
          setCardsBI(cardsBI)
        }
      })
    })();
  },[])

  const handleEditCategory = () => setShowEditCategory(true)
  const handleEditCard = () => setShowEditCard(true)

  const handleDeleteCategory = (id: number, name: string) => {
    setIdCategoryForDelete(id)
    setNameCategoryForDelete(name)
    setShowDeleteCategory(true)
    CardsByCategory(id)
  }
  
  const handleDeleteCardBI = (id: number, name: string) => {
    setIdCardBIForDelete(id)
    setNameCardBIForDelete(name)
    setShowDeleteCardBI(true)
  }
  
  const CardsByCategory = (id: number) => {
    const link: ResourceLink = {
      href: `api/card_bi/category/${id}`,
      rel: "search",
      type: "GET",
    };

    callRestApi<CardsConectaBI[]>({
      link,
      onSuccess: (Card: CardsConectaBI[]) => {
        setCardsBICategory(Card)
      },
      onError: (err: ErrorApi) => {},
      onFinally: () => {},
    }); 
  }
  
  const findCategory = searchCategoryBi(categoriesBI as CategoryBI[], searchValues?.search)
  return (
    <div>
        {showEditCategory ? <ModalEditCategoryBI
          show={showEditCategory}
          closeModal={setShowEditCategory}
          setCategoriesBI={setCategoriesBI}
          setCardsBI={setCardsBI}
          cardsBI={cardsBI}
          categoriesBI={categoriesBI}
          />
          :
          null
        }
        {showEditCard ? <ModalEditCardBI
          show={showEditCard}
          closeModal={setShowEditCard}
          setCardsBI={setCardsBI}
          cardsBI={cardsBI}
          categoriesBI={categoriesBI}
        />
          :
        null
        }
        {showDeleteCategory ? <ModalDeleteBICategory
            show={showDeleteCategory}
            closeModal={setShowDeleteCategory}
            idCategoryForDelete={idCategoryForDelete}
            nameCategoryForDelete={nameCategoryForDelete}
            setCategoriesBI={setCategoriesBI}
            cardsBICategory={cardsBICategory}
            setCardsBI={setCardsBI}
          />
          :
          null
        }
        {showDeleteCardBI ? <ModalDeleteBICard
          show={showDeleteCardBI}
          closeModal={setShowDeleteCardBI}
          idCardBIForDelete={idCardBIForDelete}
          nameCardBIForDelete={nameCardBIForDelete}
          setCardsBI={setCardsBI}
        />
          :
          null
        }
        <HeaderAdimn user={userLink} />
        <br />
        <div className="container_bi">
            <div className="container_bi_categoria">
                <h4>Editar Categorias BI</h4>
                <div className="container_edit_categories_content">
                    <SearchBI
                      titlePlaceholder="Buscar categoria..."
                    />
                    {loadingAdminBIValue?.loadingAdminBI ? (
                      <div>Carregando...</div>
                    )
                      :
                    (
                      <div className="content_bi">
                        {findCategory ? 
                            findCategory.map(cat_bi => (
                                <AdminEditCategoryBI
                                 category={cat_bi}
                                 handleEditCategory={handleEditCategory}
                                 handleDeleteCategory={handleDeleteCategory}
                                />
                            ))
                        :
                            categoriesBI.map(cat_bi => (
                                <AdminEditCategoryBI
                                  category={cat_bi}
                                  handleEditCategory={handleEditCategory}
                                  handleDeleteCategory={handleDeleteCategory}
                                />
                            ))
                        }
                    </div>
                    )
                  }
                    
                </div>
            </div>
            <div className="container_bi_card">
                <h4>Editar Cards BI</h4>
                <div className="container_edit_categories_content">
                  <SearchBI
                    titlePlaceholder="Buscar cards..."
                  />
                  <div className="content_bi">
                  {cardsBI && cardsBI.map(cardBI => (
                    <AdminEditCardBI
                      key={cardBI.id}
                      cardBI={cardBI}
                      handleEditCard={handleEditCard}
                      handleDeleteCardBI={handleDeleteCardBI}
                    />
                  ))}
                  </div>
                    
                </div>
            </div>
        </div>
    </div>
  )
}

export default EditCardBI